import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_download",
  "use": "icon-icon_download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_download\"><defs><style></style></defs><path d=\"M493.978 810.803a25.6 25.6 0 0 0 36.25 0L819.2 521.011a25.6 25.6 0 0 0-36.25-36.25l-245.76 245.76V102.4a25.6 25.6 0 0 0-51.2 0v628.531l-245.76-245.76a25.6 25.6 0 0 0-35.43 35.84zM805.274 896H218.726a25.6 25.6 0 0 0 0 51.2h586.548a25.6 25.6 0 0 0 0-51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol